import React from 'react';
import PhotoVaultComponent from 'Components/AdminSettings/AdminDetails/PhotoVaultComponents/PhotoVaultComponent';

const PhotoVault = () => {
  return <PhotoVaultComponent />;
};

export default PhotoVault;
